import { cn } from '@plato/ui/util/classes';
import { CheckIcon, RefreshCw, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { TextProps } from '../ui/text.tsx';
import Text from '../ui/text.tsx';

type IndicatorProps = {
    Icon: React.ComponentType<any>;
    text: string;
    color?: TextProps['color'];
    iconClassName?: string;
};

function Indicator({ Icon, text, iconClassName, color = 'neutral-700' }: IndicatorProps) {
    return (
        <div className={`flex items-center gap-2 text-${color}`}>
            <Icon className={cn(`h-4 w-4`, iconClassName)} />
            <Text size="xs" leading="none" color={color} className="hidden sm:block">
                {text}
            </Text>
        </div>
    );
}

type AutoSaveIndicatorProps = {
    isUpdating: boolean;
    isSuccess?: boolean;
    isError?: boolean;
};

export function AutoSaveIndicator({ isUpdating, isSuccess, isError }: AutoSaveIndicatorProps) {
    const { t } = useTranslation();

    if (!isUpdating && !isSuccess && !isError) {
        return null;
    }

    if (isUpdating) {
        return <Indicator Icon={RefreshCw} text={t('loading_dots')} iconClassName="animate-spin" />;
    }

    if (isSuccess) {
        return <Indicator Icon={CheckIcon} text={t('all_changes_saved')} />;
    }

    if (isError) {
        return <Indicator Icon={TriangleAlert} color="red-600" text={t('saving_failed')} />;
    }

    return null;
}
